//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import type { GetSpecificTargetingRequest } from './models/GetSpecificTargetingRequest';
import type { GetSpecificTargetingSettingsResponse } from './models/GetSpecificTargetingSettingsResponse';
import type { GetSpecificTargetingSettingsUsersRequest } from './models/GetSpecificTargetingSettingsUsersRequest';
import type { GetTargetingRequest } from './models/GetTargetingRequest';
import type { GetTargetingResponse } from './models/GetTargetingResponse';
import { Utilities } from './Utilities';

export class TargetingsClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        getTargetingUsers: (): string => {
            let clientRequestUrl = '/api/v1/targetings/do-get-targeting';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getSpecificTargetingUsers: (): string => {
            let clientRequestUrl = '/api/v1/targetings/do-get-specific-targeting';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getSpecificTargetingSettingsUsers: (): string => {
            let clientRequestUrl = '/api/v1/targetings/do-get-specific-targeting-settings';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    };

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Get Targeting user
     * @param body (optional) The parameter to retrieve targeting user
     * @return OK
     */
    async getTargetingUsers(
        body?: GetTargetingRequest,
    ): Promise<GetTargetingResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.getTargetingUsers();

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<GetTargetingResponse>(_response, false, []);
    }

    /**
     * Get Specific Targeting user
     * @param body (optional) The parameter to retrieve Specific targeting user
     * @return OK
     */
    async getSpecificTargetingUsers(
        body?: GetSpecificTargetingRequest,
    ): Promise<GetTargetingResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.getSpecificTargetingUsers();

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<GetTargetingResponse>(_response, false, []);
    }

    /**
     * Get Specific Targeting settings users
     * @param body (optional) The parameter to retrieve Specific targeting settings user
     * @return OK
     */
    async getSpecificTargetingSettingsUsers(
        body?: GetSpecificTargetingSettingsUsersRequest,
    ): Promise<GetSpecificTargetingSettingsResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.getSpecificTargetingSettingsUsers();

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<GetSpecificTargetingSettingsResponse>(_response, false, []);
    }
}
